<template>
  <div>
    <b-card
      v-for="project in projects"
      class="mb-3"
      :key="project.id"
      :title="project.course"
      :sub-title="`${project.id}: ${project.developer_lastname}`"
    >
      <b-table
        :items="getProject(project.id)"
        class="pt-2"
        stacked="md"
        :fields="fields"
      >
        <template v-slot:cell(id)="data">
          <b-link :to="`/projects/${data.value}/?caller=collection`">
            <b-icon icon="link45deg"></b-icon>
          </b-link>
        </template>
      </b-table>

      <GAssignLeadsForm :project="project" />
    </b-card>
  </div>
</template>

<script>
  import GAssignLeadsForm from '@/components/GAssignLeadsForm.vue'

  export default {
    name: 'GAssignLeads',
    components: {
      GAssignLeadsForm
    },
    data() {
      return {
        fields: [
          {
            key: 'id',
            label: 'Project record'
          },
          {
            key: 'course_duration',
            label: 'Course duration'
          },
          {
            key: 'request_type',
            label: 'Request type'
          },
          {
            key: 'delivery_date',
            label: 'Delivery date',
            formatter: 'cleanDate'
          },
          {
            key: 'cohort',
            label: 'Cohort'
          }
        ]
      }
    },
    created() {
      this.$store.dispatch('getProjects')
    },
    computed: {
      projects() {
        return this.$store.getters.projectsToBeAssigned
      }
    },
    methods: {
      getProject(id) {
        return this.$store.getters.projectsToBeAssigned.filter(
          project => project.id === id
        )
      },
      cleanDate(datetimestamp) {
        return datetimestamp.substring(0, 10)
      }
    }
  }
</script>

<style scoped></style>
